export interface ReasonOption {
  value: string
  labelEn: string
  labelAr: string
}

export const ORDER_CANCEL_REASONS: ReasonOption[] = [
  { value: 'client_request', labelEn: 'Client Request', labelAr: 'طلب العميل' },
  { value: 'duplicate_order', labelEn: 'Duplicate Order', labelAr: 'طلب مكرر' },
  { value: 'incorrect_details', labelEn: 'Incorrect Details', labelAr: 'تفاصيل غير صحيحة' },
  { value: 'no_longer_needed', labelEn: 'No Longer Needed', labelAr: 'لم تعد هناك حاجة' },
  { value: 'other', labelEn: 'Other', labelAr: 'أخرى' },
]

export const APPOINTMENT_CANCEL_REASONS: ReasonOption[] = [
  { value: 'schedule_conflict', labelEn: 'Schedule Conflict', labelAr: 'تعارض في الجدول' },
  { value: 'client_request', labelEn: 'Client Request', labelAr: 'طلب العميل' },
  { value: 'provider_unavailable', labelEn: 'Provider Unavailable', labelAr: 'مقدم الخدمة غير متاح' },
  { value: 'no_longer_needed', labelEn: 'No Longer Needed', labelAr: 'لم تعد هناك حاجة' },
  { value: 'other', labelEn: 'Other', labelAr: 'أخرى' },
]

export const SERVICE_CANCEL_REASONS: ReasonOption[] = [
  { value: 'no_longer_needed', labelEn: 'No Longer Needed', labelAr: 'لم تعد هناك حاجة' },
  { value: 'client_request', labelEn: 'Client Request', labelAr: 'طلب العميل' },
  { value: 'duplicate_service', labelEn: 'Duplicate Service', labelAr: 'خدمة مكررة' },
  { value: 'provider_unavailable', labelEn: 'Provider Unavailable', labelAr: 'مقدم الخدمة غير متاح' },
  { value: 'other', labelEn: 'Other', labelAr: 'أخرى' },
]

export const OPS_REJECT_REASONS: ReasonOption[] = [
  { value: 'incomplete_documentation', labelEn: 'Incomplete Documentation', labelAr: 'وثائق غير مكتملة' },
  { value: 'invalid_information', labelEn: 'Invalid Information', labelAr: 'معلومات غير صحيحة' },
  { value: 'service_unavailable', labelEn: 'Service Unavailable', labelAr: 'الخدمة غير متاحة' },
  { value: 'out_of_coverage', labelEn: 'Out of Coverage Area', labelAr: 'خارج منطقة التغطية' },
  { value: 'other', labelEn: 'Other', labelAr: 'أخرى' },
]

export const ORDER_REFUND_REASONS: ReasonOption[] = [
  { value: 'service_not_provided', labelEn: 'Service Not Provided', labelAr: 'لم يتم تقديم الخدمة' },
  { value: 'poor_quality', labelEn: 'Poor Quality of Service', labelAr: 'جودة خدمة سيئة' },
  { value: 'client_request', labelEn: 'Client Request', labelAr: 'طلب العميل' },
  { value: 'duplicate_charge', labelEn: 'Duplicate Charge', labelAr: 'رسوم مكررة' },
  { value: 'other', labelEn: 'Other', labelAr: 'أخرى' },
]
